import React from 'react'
import irelandApi from '../irelandApi'
import {actions} from 'react-redux-form'
import {toast} from 'react-toastify';
import store, {history} from '../store'
import ToastMessage from '../components/common/toast-message'

export const getCurrentUser = () => (dispatch) => {
  dispatch({type: "GET_CURRENT_USER_PENDING", payload: []});
  return irelandApi.get('/api/current_user')
    .then((response) => {
      dispatch({type: "GET_CURRENT_USER_FULFILLED", payLoad: response.data});
    })
    .catch((error) => {
      dispatch({type: 'GET_CURRENT_USER_REJECTED', payLoad: error.data})
    })
};

export const getMyProfile = (action = 'GET_PROFILE') => (dispatch) => {
  dispatch({type: `${action}_PENDING`, payload: []});
  return irelandApi.get('/api/users/my_profile')
    .then((response) => {
      const attributes = response.data.data.attributes;
      const data = {
        personal_address_1: attributes["personal-address-1"] || undefined,
        personal_address_2: attributes["personal-address-2"] || undefined,
        personal_address_3: attributes["personal-address-3"] || undefined,
        personal_address_4: attributes["personal-address-4"] || undefined,
        personal_eircode: attributes["personal-eircode"] || undefined,
        comms_email: attributes['comms-email'] || false,
        comms_mobile: attributes['comms-mobile'] || false,
        email: attributes.email || undefined,
        mobile: attributes.mobile || undefined,
        should_opt_in: attributes["should-opt-in"] || false,
        marketing_accepted: (attributes['marketing-accepted'] || false).toString(),
        has_reward_outlet: attributes['has-reward-outlet'],
      };

      store.dispatch(actions.load('deep.my_profile', data));
      dispatch({type: 'TOGGLE_PRIVACY_MODAL', payLoad: !attributes['privacy-policy-accepted']});

      dispatch({
        type: `${action}_FULFILLED`,
        payLoad: response.data,
      });

      dispatch({type: 'TOGGLE_MARKETING_MODAL', payLoad: attributes['marketing-accepted'] == null });

      // LOAD BASKET ITEMS
      dispatch({
        type: 'LOAD_BASKET_ITEMS', payLoad: {
          basket_data: response.data.data.attributes.basket[0],
          basket_total: response.data.meta["basket-total"],
          basket_total_with_current_promotions: response.data.meta["basket-total-with-current-promotions"],
        }
      });

      dispatch({
          type: 'UPDATE_DELIVERY_ADDRESS',
          payload: response.data.data.attributes.basket[0]['delivery_address']
      })

      dispatch({
        type: 'GET_UNREAD_MESSAGE_COUNT', payLoad: {
          unread_messages: response.data.meta["unread-messages"]
        }
      });

      if (data.should_opt_in) {
        dispatch({type: 'TOGGLE_PERSONAL_REWARDS_SETTINGS_DIALOG', payLoad: true});
      }
    })
    .catch((error) => {
      dispatch({type: `${action}__REJECTED`, payLoad: error.data})
    })
};

export const getAdminMyProfile = (action = 'GET_PROFILE') => (dispatch) => {
  dispatch({type: `${action}_PENDING`, payload: []});
  return irelandApi.get('/api/admin/users/my_profile')
    .then((response) => {
      const attributes = response.data.data.attributes;
      let mobileCheck = false;
      let emailCheck = false;

      const data = {
        title: attributes["title"] || undefined,
        first_name: attributes["first-name"] || undefined,
        last_name: attributes["last-name"] || undefined,
        comms_email: attributes["comms-email"] || false,
        comms_mobile: attributes["comms-mobile"] || false,
        email: attributes.email || undefined,
        mobile: attributes.mobile || undefined,
      };
      store.dispatch(actions.load('deep.admin_my_profile', data));
      dispatch({type: `${action}_FULFILLED`, payLoad: response.data})
    })
    .catch((error) => {
      dispatch({type: `${action}__REJECTED`, payLoad: error.data})
    })
};

export const saveMyProfile = (payLoad) => {
  let formData = new FormData();

  Object.keys(payLoad).forEach(key => {
    if (payLoad[key] === undefined) {
      formData.append(`my_profile[${key}]`, '')
    } else {
      formData.append(`my_profile[${key}]`, payLoad[key])
    }
  });

  const config = {
    headers: {'content-type': 'multipart/form-data'}
  };

  return irelandApi.patch('/api/users/my_profile', formData, config)
    .then((response) => {
      store.dispatch(actions.resetValidity('deep.my_profile'));
      toast.success(<ToastMessage iconStyle="success" message="Profile saved successfully"/>);
    })
    .catch((error) => {
      toast.error(<ToastMessage iconStyle="error" message="An error occurred during save"/>);
      store.dispatch(actions.resetValidity('deep.my_profile'));
      const data = {
        ...error.response.data.errors
      };
      return Promise.reject(data)
    })
};

export const saveAdminMyProfile = (payLoad) => {
  return irelandApi.patch('/api/admin/users/my_profile', {my_profile: payLoad})
    .then((response) => {
      store.dispatch(actions.resetValidity('deep.admin_my_profile'));
      toast.success(<ToastMessage iconStyle="success" message="Profile saved successfully"/>);
    })
    .catch((error) => {
      toast.error(<ToastMessage iconStyle="error" message="An error occurred during save"/>);
      store.dispatch(actions.resetValidity('deep.admin_my_profile'));
      const data = {
        ...error.response.data
      };
      return Promise.reject(data)
    })
};

export const closeAccount = () => {
  // toast.success(<ToastMessage iconStyle="success" message="Account suspended, redirecting to login..."/>);
  // history.push('/logout');
  return irelandApi.delete('/api/users')
    .then((response) => {
      toast.success(<ToastMessage iconStyle="success" message="Account suspended, redirecting to login..."/>);
      store.dispatch({type: 'DELETE_ACCOUNT_SUCCESS'});
    })
    .catch((error) => {
      const data = {
        ...error.response.data.errors
      };
      return Promise.reject(data);
    })
};

export const acceptPrivacy = () => dispatch => {
  dispatch({type: 'PATCH_ACCEPT_PRIVACY_PENDING'});

  return irelandApi.patch('/api/users/accept_privacy_policy')
    .then(() => {
      toast.success(<ToastMessage iconStyle="success" message="You have accepted our privacy policy"/>);
      dispatch({type: 'PATCH_ACCEPT_PRIVACY_SUCCESS'});
    })
    .catch((error) => {
      toast.error(<ToastMessage iconStyle="error" message="An error occurred. Cannot accept privacy policy."/>);
      dispatch({type: 'PATCH_ACCEPT_PRIVACY_REJECTED'});

    });
};

export const acceptMarketing = (payLoad, dispatch) => irelandApi.patch('/api/users/marketing_consent', {marketing_consent: {...payLoad}})
  .then(() => {
    toast.success(<ToastMessage iconStyle="success" message="Your marketing preferences has been saved"/>);
    dispatch({type: 'TOGGLE_MARKETING_MODAL', payLoad: false});
  })
  .catch((error) => {
    toast.error(<ToastMessage iconStyle="error" message="An error occurred. Cannot accept marketing."/>);
    return Promise.reject(error);
  });

export const updateVoucher = (payload) => () =>
  irelandApi.patch('/api/users/update_voucher', {voucher: { voucher_type_id: payload }})
    .then(() => {
      toast.success(<ToastMessage iconStyle="success" message="Your voucher preferences has been saved"/>);
    })
    .catch((error) => {
      toast.error(<ToastMessage iconStyle="error" message="An error occurred. Cannot update voucher."/>);
      return Promise.reject(error);
    });

export const newCustomerNumberAcknowledged = () => {
  return irelandApi.patch('/api/users/new_customer_number_acknowledged')
    .then(() => {
      toast.success(<ToastMessage iconStyle="success" message="New Customer Numbers has been confirmed."/>);
    })
    .catch(() => {
      toast.error(<ToastMessage iconStyle="error" message="An error occurred. Cannot confirm new Customer Numbers"/>);
    });
};



// WEBPACK FOOTER //
// ./src/actions/user.js